import ModernTradeNewFileUpload from "../pages/dashboard/modernTrade/ModernTradeNewFileUpload";
import ViewTableFilterSearch from "../pages/dashboard/modernTrade/ViewTableFilterSearch";
import Motherboard from "../pages/dashboard/Motherboard";
import PrivateRoute from "../PrivateRoute";
import Room from "../pages/meetingroom/Room";
import User from "../user/User";
import RoomDashboard from "../pages/meetingroom/RoomDashboard";
import ArtWork from "../pages/artwork/ArtWork";

const dashboardRoutes = [
  {
    path: "/dashboard",
    element: (
      <PrivateRoute>
        <Motherboard />
       </PrivateRoute>
    ),
  },
   {
    path: "/profile",
    element: (
      <PrivateRoute>
        <User />
      </PrivateRoute>
    ),
  },
  {
    path: "/dashboard/modern-trade",
    element: (
      <PrivateRoute>
        <ViewTableFilterSearch />
      </PrivateRoute>
    ),
  },
  {
    path: "/dashboard/art-work",
    element: (
      <PrivateRoute>
        <ArtWork />
      </PrivateRoute>
    ),
  },
  {
    path: "/dashboard/meeting-room",
    element: (
     
        <RoomDashboard />
      
    ),
  },
  {
    path: "/dashboard/meeting-room/room-booking",
    element: (
      <PrivateRoute>
        <Room />
      </PrivateRoute>
    ),
  },
  {
    path: "/dashboard",
    element: (
      <PrivateRoute>
        <Motherboard />
      </PrivateRoute>
    ),
  },
  {
    path: "dashboard/modern-trade",
    element: (
      <PrivateRoute>
        <ViewTableFilterSearch />
      </PrivateRoute>
    ),
  },
  {
    path: "/dashboard/mt-upload-data",
    element: (
      <PrivateRoute>
        <ModernTradeNewFileUpload />
      </PrivateRoute>
    ),
  },
  {
    path: "/dashboard/mt-view-data",
    element: (
      <PrivateRoute>
        <ViewTableFilterSearch />
      </PrivateRoute>
    ),
  }
];

export default dashboardRoutes;